const CONSENT_VERSION = 'AU_consent';

const REGISTRATION_CONSENTS_KEYS_LOOKUP = {
  EMPLOYED_ADULT_KEY: 'employedAdult',
  ELECTRONIC_DOCUMENTS_KEY: 'electronicDocuments',
  PRIVACY_POLICY_KEY: 'privacyPolicy',
  IDENTITY_CHECK_CONSENT_KEY: 'identityCheckConsent',
};

const REGISTRATION_CONSENTS_PAYLOAD_LOOKUP = {
  EMPLOYED_ADULT: 'EMPLOYED_ADULT',
  IDENTITY_CHECK: 'IDENTITY_CHECK',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  DISCLOSURE_DOCS: 'DISCLOSURE_DOCS',
};

export const REGISTRATION_CONSENTS_KEYS = Object.values(REGISTRATION_CONSENTS_KEYS_LOOKUP);

export const REGISTRATION_CONSENTS_PAYLOAD = [{
  consentType: REGISTRATION_CONSENTS_PAYLOAD_LOOKUP.EMPLOYED_ADULT,
  value: true,
  version: CONSENT_VERSION,
},
{
  consentType: REGISTRATION_CONSENTS_PAYLOAD_LOOKUP.IDENTITY_CHECK,
  value: true,
  version: CONSENT_VERSION,
},
{
  consentType: REGISTRATION_CONSENTS_PAYLOAD_LOOKUP.PRIVACY_POLICY,
  value: true,
  version: CONSENT_VERSION,
},
{
  consentType: REGISTRATION_CONSENTS_PAYLOAD_LOOKUP.DISCLOSURE_DOCS,
  value: true,
  version: CONSENT_VERSION,
}];
